document.addEventListener('DOMContentLoaded', function(event) {
  const toasts = document.querySelectorAll(".toast-container .toast");

  toasts.forEach((toast) => {
    const toastBootstrap = bootstrap.Toast.getOrCreateInstance(toast)
    toastBootstrap.show()
  });
});
